<template>
<div class="detail-container">
	<!-- 导航栏 -->
	<van-nav-bar 
		:title="$t('common.pldtitle')" 
		left-text="" 
		@click-left="back()" 
		left-arrow 
		class="custom-nav-bar"
	>
	</van-nav-bar>
	
	<!-- 内容区域 -->
	<div class="content-wrapper">
		<div class="content-card">
			<!-- 标题区域 -->
			<div class="title-section">
				<div class="icon-wrapper">
					<!-- 本地对话图标 -->
					<img 
						src="/img/duihua.png" 
						alt="对话图标" 
						class="logo-img"
						@load="onImageLoad"
						@error="onImageError"
					/>
					<!-- 备用SVG图标 -->
					<svg v-if="!logoLoaded" t="1721097804862" class="icon" viewBox="0 0 1024 1024" version="1.1"
					xmlns="http://www.w3.org/2000/svg" p-id="5354" width="32" height="32">
						<path d="M102.4 102.4m307.2 0l204.8 0q307.2 0 307.2 307.2l0 204.8q0 307.2-307.2 307.2l-204.8 0q-307.2 0-307.2-307.2l0-204.8q0-307.2 307.2-307.2Z"
						fill="#667eea" fill-opacity=".2" p-id="5355">
						</path>
						<path d="M665.6 481.28a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H336.67072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 235.52 583.68v-20.48a81.92 81.92 0 0 1 81.92-81.92z m30.72-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L737.28 501.76l-38.42048-61.48096A83.43552 83.43552 0 0 1 696.32 440.32H450.56a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
						fill="#667eea" fill-opacity=".4" p-id="5356">
						</path>
						<path d="M634.88 532.48a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H305.95072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 204.8 634.88v-20.48a81.92 81.92 0 0 1 81.92-81.92z m102.4-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L778.24 552.96l-38.42048-61.48096A83.43552 83.43552 0 0 1 737.28 491.52H491.52a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
						fill="#667eea" p-id="5357">
						</path>
						<path d="M341.68832 607.04768c5.85728 0 10.38336 1.86368 13.84448 5.59104 3.9936 3.72736 5.85728 8.51968 5.85728 14.37696 0 5.3248-1.86368 10.11712-5.85728 14.11072-3.46112 3.46112-7.9872 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.9936-5.85728-8.78592-5.85728-14.11072 0-5.85728 2.12992-10.6496 5.85728-14.37696 3.9936-3.72736 8.78592-5.59104 14.11072-5.59104z m258.2528 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.92416 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.65792 0c5.3248 0 10.11712 1.59744 13.84448 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824 0 5.3248-1.86368 9.85088-5.59104 13.57824a19.08736 19.08736 0 0 1-13.84448 5.59104c-5.3248 0-10.11712-1.86368-13.84448-5.3248a18.8928 18.8928 0 0 1-5.85728-13.84448c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 14.11072-5.3248zM510.95552 378.88c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104A17.75616 17.75616 0 0 1 491.52 397.78304c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.92416 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104a17.75616 17.75616 0 0 1-5.85728-13.57824c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.65792 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-2.12992 10.11712-5.85728 13.84448c-3.72736 3.46112-8.51968 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-13.84448-5.59104a18.4832 18.4832 0 0 1-5.59104-13.57824c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 13.84448-5.3248z"
						fill="#764ba2" p-id="5358">
						</path>
					</svg>
				</div>
				<div class="title-content">
					<h1 class="title-text">
						{{plInfo.title}}
					</h1>
					<div class="author-info">
						<span class="author-label">{{$t('author')}}</span>
						<span class="author-name">{{plInfo.auther}}</span>
					</div>
				</div>
			</div>

			<!-- 内容区域 -->
			<div class="content-section">
				<div class="content-text">
					{{plInfo.content}}
				</div>
			</div>

			<!-- 时间信息 -->
			<div class="time-section">
				<span class="time-text">
					{{plInfo.time}}
				</span>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      plInfo:{},
      logoLoaded: false,
    };
  },
  methods: {
    onImageLoad() {
      this.logoLoaded = true;
    },
    onImageError() {
      this.logoLoaded = false;
      console.log('图片加载失败，使用备用图标');
    },
    back(){
      this.$router.push({path:'Pl'})
    },
    getVideoInfo(){
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'pinglun_get_info'
      }).then(res=>{
        this.plInfo = res.data;
      })
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Home'})
    }else {
      this.getVideoInfo();
    }
  }
};
</script>

<style lang='less' scoped>
// 渐变颜色定义
@gradient-start: #667eea;
@gradient-end: #764ba2;

.detail-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa, #f0f2f5);
}

// 导航栏样式
.custom-nav-bar {
  position: relative;
  z-index: 999;
  height: 3rem;
  line-height: 3rem;
  background: linear-gradient(135deg, @gradient-start, @gradient-end) !important;
  
  .van-nav-bar__title, .van-nav-bar .van-icon {
    color: #fff;
    font-weight: 600;
  }
}

// 内容包装
.content-wrapper {
  padding: 1rem;
}

// 内容卡片
.content-card {
  background: #fff;
  border-radius: 16px;
  border: 2px solid transparent;
  box-shadow: 
    0 4px 20px rgba(102, 126, 234, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.9);
  padding: 1.5rem;
  position: relative;
  overflow: hidden;
  
  // 发光边框效果
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, @gradient-start, @gradient-end);
    border-radius: 18px;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 0.1;
  }
}

// 标题区域
.title-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.icon-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, fade(@gradient-start, 10%), fade(@gradient-end, 10%));
  border-radius: 12px;
  margin-right: 1rem;
  border: 1px solid fade(@gradient-start, 15%);
  position: relative;
  overflow: hidden;
  
  .logo-img {
    width: 28px;
    height: 28px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
  
  .icon {
    width: 28px;
    height: 28px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
}

.title-content {
  flex: 1;
}

.title-text {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
  letter-spacing: -0.2px;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.author-label {
  font-size: 0.85rem;
  color: #666;
}

.author-name {
  font-size: 0.9rem;
  color: @gradient-end;
  font-weight: 500;
}

// 内容区域
.content-section {
  margin-bottom: 1.5rem;
}

.content-text {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}

// 时间区域
.time-section {
  text-align: right;
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.time-text {
  font-size: 0.85rem;
  color: #999;
  font-weight: 400;
}

// 响应式设计
@media (max-width: 768px) {
  .content-wrapper {
    padding: 0.75rem;
  }
  
  .content-card {
    padding: 1.25rem;
    border-radius: 14px;
  }
  
  .title-text {
    font-size: 1.1rem;
  }
  
  .content-text {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .icon-wrapper {
    width: 42px;
    height: 42px;
    margin-right: 0.875rem;
    
    .logo-img,
    .icon {
      width: 24px;
      height: 24px;
    }
  }
}

// 加载状态
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #999;
}

// 错误状态
.error-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #ff4d4f;
  
  .retry-btn {
    margin-top: 1rem;
    background: linear-gradient(135deg, @gradient-start, @gradient-end);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    cursor: pointer;
  }
}
</style>